import { Tabs as MuiTabs, styled, Tab } from '@mui/material';
import * as React from 'react';
import { Link } from 'react-router';

import { IHeaderTab } from '../LayoutPreference/layoutTypes';

interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <MuiTabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    variant="scrollable"
  />
))(({ theme }) => ({
  '& .MuiTabs-indicator': {
    display: 'flex',
    height: '3px',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',

    backgroundColor: theme.palette.secondary.main,
  },
}));

const StyledTab = styled((props: any) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'uppercase',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
  }),
);

/** @deprecated Temporary dual-layout rollout legacy tabs. Remove when legacy layout is retired. */
export default function TabsLegacy({
  value,
  tabs,
}: {
  value: number;
  tabs: IHeaderTab[];
}) {
  if (tabs === undefined || tabs.length === 0) return <></>;

  return (
    <StyledTabs value={value} aria-label="styled tabs example">
      {tabs?.map((item, index) => (
        <StyledTab
          label={item.name}
          key={index}
          to={item.path}
          component={Link}
        />
      ))}
    </StyledTabs>
  );
}
